/*
 * Field Mode kept ONE unfinished capture in localStorage until 2026-10-06
 * ('mb_field_draft'), with no owner on it. Field Mode now moves it into its
 * own store for whoever opens it next (utils/fieldBatches.js,
 * adoptLegacyDraft), so on a shared phone it must not outlive the session it
 * was written in: signing out, or being signed out, forgets it.
 */
export const UNOWNED_DRAFT_KEY = 'mb_field_draft';

export function forgetUnownedDraft(storage = globalThis.localStorage) {
  try { storage?.removeItem(UNOWNED_DRAFT_KEY); } catch { /* storage refused: nothing to forget */ }
}
